export default "__VITE_ASSET__BWTSI64S__"